/**
 * Generates a random guid.
 *
 * This is currently used to generate a unique id
 * for new tract item records added to the edit grid.
 */
export function GenerateGuid(): string {
  function s4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
    s4() + "-" + s4() + s4() + s4();
}

/**
 * Helper function that builds a string with the zone
 * and zone qualifier.
 *
 * @param qualifier
 *     The zone qualifier.
 *
 *     Example: TOP, BASE, SURFACE
 *
 * @param zone
 *     The zone name.
 *
 *     Example: VIKING, COLONY
 */
export function buildQualifiedZone(qualifier: string, zone: string): string {
    let zoneSummary = "";

    if (qualifier && (qualifier.toLowerCase() === "surface" || qualifier.toLowerCase() === "basement")) {
        zoneSummary = qualifier;
    } else if (zone) {
        if (!qualifier) {
            zoneSummary += zone;
        } else {
            zoneSummary += qualifier + " " + zone;
        }
    }

    return zoneSummary;
}



// WEBPACK FOOTER //
// ./app/document-landright-ts/utils.ts